import { createFileRoute } from '@tanstack/react-router'

import HomePage from '@/layouts/themes/antau/pages/home'

export const Route = createFileRoute('/_layout/')({
  component: HomePage,
})
